import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import CreateDocumentFields from "./CreateDocumentFields";
import { LangContext } from "../LangContext.jsx";
const fieldTypes = [
    {
        id: 'text',
        title: 'Texto',
        icon: 'fa-font'
    },
    {
        id: 'paragraph',
        title: 'Párrafo',
        icon: 'fa-paragraph'
    },
    {
        id: 'date',
        title: 'Fecha',
        icon: 'fa-calendar'
    },
    {
        id: 'number',
        title: 'Número',
        icon: 'fa-number'
    }
    // {
    //     id: 'checkbox',
    //     title: 'Checkbox',
    //     icon: 'fa-check-square'
    // },
    // {
    //     id: 'radio',
    //     title: 'Radio',
    //     icon: 'fa-check-circle'
    // },
    // {
    //     id: 'email',
    //     title: 'Email',
    //     icon: 'fa-envelope'
    // },
    // {
    //     id: 'phone',
    //     title: 'Teléfono',
    //     icon: 'fa-phone-alt'
    // },
    // {
    //     id: 'file',
    //     title: 'File upload',
    //     icon: 'fa-file-alt'
    // },
    // {
    //     id: 'website',
    //     title: 'Website',
    //     icon: 'fa-link'
    // }
];

class DocumentFields extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            indexSelected: null,
            fields: [],
            nextId: 1,
            dateValidationComponent:'',
        };
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handlePlaceholderChange = this.handlePlaceholderChange.bind(this);
        this.handleRequiredChange = this.handleRequiredChange.bind(this);
        this.changeToIndex = this.changeToIndex.bind(this);
        this.removeIndex = this.removeIndex.bind(this);
        this.save = this.save.bind(this);
    }

    componentWillReceiveProps(props) { 
        if (props.selected_fields != null) {
            this.setState({
                indexSelected: null,
                fields: props.selected_fields
            },function(){
            })
        }
    }

    onDragEnd = result => {
        if (!result.destination) return;

        if (result.destination.droppableId == 'newField') {
            try {
                const f = {
                    id: this.state.nextId,
                    document_field_type: fieldTypes[result.source.index].id,
                    title: fieldTypes[result.source.index].title,
                    placeholder: "",
                    required: false
                }

                this.setState(prevState => ({
                    fields: [...prevState.fields, f],
                    indexSelected: prevState.fields.length,
                    nextId: prevState.nextId + 1,
                }))
            } catch (error) {
                console.log(error);
            }
        }
    }

    handleTitleChange(e) {
        const fields = [...this.state.fields];
        fields[this.state.indexSelected].title = e.target.value;
        this.setState({ fields: fields });
    }

    handlePlaceholderChange(e) {
        const fields = [...this.state.fields];
        fields[this.state.indexSelected].placeholder = e.target.value;
        this.setState({ fields: fields });
    }

    handleRequiredChange(e) {
        const fields = [...this.state.fields];
        fields[this.state.indexSelected].required = e.target.checked;
        this.setState({ fields: fields });
    }

    changeToIndex(newIndex) {
        this.setState({indexSelected: newIndex});
    }

    removeIndex(e, index) {
        e.stopPropagation();
        const fields = [...this.state.fields];
        fields.splice(index, 1);
        this.setState({ indexSelected: null, fields: fields });
    }

    deleteField = (id) => {
        this.setState((prevState) => ({
            fields: prevState.fields.filter((field) => field.id !== id),
        }));
    };

    async save() {
        const params = JSON.stringify({
            document: this.props.document_id,
            fields: this.state.fields
        })
        await axios.post(
            '/api/documents/fields',
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then(function(response) {
        })
        .catch(function(error) {
            console.log(error);
        });
    }

    getIconForType(typeId) {
        for (const t of fieldTypes) {
            if (typeId == t.id) {
                return t.icon;
            }
        } 
    } 

    updateParentState = (updatedState) => {
        const { id ,selectedComponent,cancelValidation} = updatedState;  
        if(cancelValidation == true){
            this.setState({dateValidationComponent:false},function(){
                this.props.updateSelectedDateValidationComponent(false);
            })
        }
        if(selectedComponent != ''){
            this.setState({dateValidationComponent:selectedComponent},function(){
                this.props.updateSelectedDateValidationComponent(selectedComponent);
            })
        }
        this.setState((prevState) => ({
            fields: prevState.fields.map((field) =>
                field.id === id ? { ...field, ...updatedState } : field
            ),
        }) );
    }
    render() {
        const { lang } = this.context; 
        return (
            <div> 
                <div className="card mt-6 p-9">
                    <p>{lang.get('messages.informacion_adicional_a_solicitar')}</p>
                    <div className="card mt-3 p-9 bg-light-light">
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="fields">
                                {(provided) => (
                                    <div className="row align-center" {...provided.droppableProps} ref={provided.innerRef}>
                                        <div className="col-sm-3">
                                            <p className="text-center">{lang.get('messages.campos_disponibles')}</p>
                                            <div className="row">
                                                {fieldTypes.map(({id, title, icon}, index) => {
                                                    return (<div key={title} className="col-sm-6 p-1">
                                                        <Draggable key={id.toString()} draggableId={id.toString()} index={index}>
                                                            {(provided) => (
                                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                    <div className="card py-6 text-center">
                                                                        <span>
                                                                            {title == 'Número' && 
                                                                                <div className="mb-3"> 
                                                                                    <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M4.63202 19.9948C4.6268 19.8959 4.62159 19.8022 4.62159 19.7034C4.62159 15.6232 4.62159 11.5483 4.62159 7.46812C4.62159 7.38486 4.62159 7.30159 4.62159 7.21832C4.52248 7.1975 4.47553 7.26516 4.42337 7.30679C3.14017 8.24356 1.71093 8.87328 0.203441 9.34686C0.0365213 9.39891 0 9.34686 0 9.19074C0.00521623 7.81681 0.00521623 6.44809 0 5.07416C0 4.90762 0.0782486 4.85558 0.213871 4.80874C1.73179 4.30913 3.02021 3.44523 4.13126 2.3159C4.71548 1.72261 5.12756 1.02004 5.38837 0.228988C5.44575 0.057247 5.524 0 5.70656 0C6.85935 0.0104085 8.01213 0.0104085 9.17014 0C9.37357 0 9.42052 0.0624512 9.42052 0.255009C9.4153 6.77075 9.4153 13.2917 9.4153 19.8074C9.4153 19.8699 9.40487 19.9375 9.40487 20C7.81392 19.9948 6.22297 19.9948 4.63202 19.9948Z" fill="#C2C2C2"/>
                                                                                    </svg>
                                                                                </div>
                                                                            }
                                                                            {title != 'Número' && 
                                                                                <div className="mb-3">
                                                                                    <i className={`fa ${icon} icon icon-xl`}></i>
                                                                                </div> 
                                                                            }  
                                                                            {lang.get('messages.'+title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""))}  
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    </div>);
                                                })}
                                            </div>
                                        </div>
                                        <div className="col-sm-9 p-5"> 
                                            <Droppable droppableId="newField">
                                                {(provided) => (
                                                    <div {...provided.droppableProps} ref={provided.innerRef} style={{borderStyle: 'dashed'}} className="card text-center border-primary mb-3">
                                                        <p className="m-4">{lang.get('messages.arrastra_el_tipo_de_campo_que_quieras_dar_de_alta_aqui')}</p>
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>

                                            <div className="accordion text-dark-75  font-size-lg" id="accordionExample">
                                                {this.state.fields.map(({id, document_field_type, title, type, conditions,placeholder}, index) => {
                                                return <CreateDocumentFields 
                                                            key={id} id={id}  
                                                            document_field_type={document_field_type} 
                                                            field={title} 
                                                            title={title} 
                                                            placeholder={placeholder} 
                                                            type={type}
                                                            conditions={conditions}
                                                            document={this.props.document}
                                                            deleteField={this.deleteField}
                                                            updateParentState={this.updateParentState} 
                                                            dateValidationComponent={this.state.dateValidationComponent}
                                                        /> 
                                                })}
                                            </div>
                                        </div> 
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
            </div>
        );
    }
}

export default DocumentFields;

if (document.getElementById('DocumentFields')) {
    ReactDOM.render(<DocumentFields />, document.getElementById('DocumentFields'));
}
